(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ec-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ec-glow-slideshow')) {
  customElements.define('ec-glow-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();

      const on = (target, event, callback) =>
        target.addEventListener(event, callback, {
          signal: this.abort.signal
        });

      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.track = this.querySelector('.ec-slides__track');
      this.play = this.querySelector('[data-play]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.hover = false;

      this.running =
        this.dataset.autoplay === 'true' &&
        !this.motion.matches &&
        !window.Shopify?.designMode;

      const controls = this.querySelector('.ec-slides__controls');
      if (controls) controls.hidden = this.slides.length < 2;

      on(this, 'click', event => {
        const button = event.target.closest('button');
        if (!button) return;

        if (button.hasAttribute('data-play')) {
          this.running = !this.running;
        } else if (
          button.hasAttribute('data-step') ||
          button.hasAttribute('data-index')
        ) {
          this.running = false;
          this.show(
            button.hasAttribute('data-index')
              ? Number(button.dataset.index)
              : this.index + Number(button.dataset.step)
          );
        }

        this.schedule();
      });

      on(this, 'mouseenter', () => {
        this.hover = true;
        this.schedule();
      });

      on(this, 'mouseleave', () => {
        this.hover = false;
        this.schedule();
      });

      on(this, 'focusin', event => {
        if (event.target !== this.play) {
          this.running = false;
          this.schedule();
        }
      });

      on(document, 'visibilitychange', () => this.schedule());

      on(this.motion, 'change', () => {
        this.running = false;
        this.schedule();
      });

      on(this, 'shopify:block:select', event => {
        const index = this.slides.findIndex(
          slide => slide.dataset.blockId === event.detail.blockId
        );

        if (index >= 0) {
          this.running = false;
          this.show(index);
          this.schedule();
        }
      });

      on(this.track, 'pointerdown', event => {
        this.start =
          event.pointerType === 'touch' &&
          !event.target.closest('a,button')
            ? { x: event.clientX, y: event.clientY }
            : null;
      });

      on(this.track, 'pointerup', event => {
        if (!this.start) return;

        const dx = event.clientX - this.start.x;
        const dy = event.clientY - this.start.y;
        this.start = null;

        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          this.running = false;
          this.show(this.index + (dx < 0 ? 1 : -1));
          this.schedule();
        }
      });

      on(this.track, 'pointercancel', () => {
        this.start = null;
      });

      this.show(0);
      this.schedule();
    }

    show(index) {
      if (!this.slides.length) return;

      this.index = (index + this.slides.length) % this.slides.length;

      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
      });

      this.dots.forEach((dot, i) => {
        dot.setAttribute('aria-current', String(i === this.index));
      });
    }

    schedule() {
      clearTimeout(this.timer);

      if (this.play) {
        this.play.textContent = this.running ? 'Pause' : 'Play';
        this.play.hidden = this.motion.matches;
      }

      this.track.setAttribute(
        'aria-live',
        this.running ? 'off' : 'polite'
      );

      if (
        !this.running ||
        this.hover ||
        document.hidden ||
        this.motion.matches ||
        this.slides.length < 2
      ) return;

      this.timer = setTimeout(() => {
        this.show(this.index + 1);
        this.schedule();
      }, Math.max(5, Number(this.dataset.speed) || 6) * 1000);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
